/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/arrow-up': {
    width: 16,
    height: 16,
    viewBox: '0 0 29 29',
    data: '<path pid="0" d="M17.5 8.9L3.4 23.1l-3-3L14.5 5.9l3 3z"/><path pid="1" d="M14.5 5.9L28.6 20l-3 3L11.5 8.9l3-3z"/>'
  }
})
